import './Footer.css'
import { Link } from 'react-router-dom';

const footer = ({ videoSelected, onVideo }) => {

    const handleMouseClick = (isSelected) => {
        videoSelected(isSelected);
    }

    return (
        <div className="footer">
            <ul className='footer-ul spacing'>
                <div className={`footer-name ${onVideo ? 'onVideo' : ''}`}>
                    <li><Link to="/about" onClick={() => handleMouseClick(false)}>ABOUT</Link></li>
                </div>
                <div className={`work-text ${onVideo ? 'onVideo' : ''}`}>
                    <li><Link to="/contact" onClick={() => handleMouseClick(false)}>CONTACT</Link></li>
                </div>
            </ul>
        </div>
    )
}

export default footer;